import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "questionaireList"
  }, [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("问卷名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("问卷名称"),
      allowClear: ""
    },
    model: {
      value: _vm.form.questionnaireName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "questionnaireName", $$v);
      },
      expression: "form.questionnaireName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("申请人")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("申请人"),
      allowClear: ""
    },
    model: {
      value: _vm.form.userName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userName", $$v);
      },
      expression: "form.userName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("保单归属")
    }
  }, [_c("a-select", {
    attrs: {
      "show-search": "",
      "option-filter-prop": "label",
      placeholder: _vm.$t("请选择") + _vm.$t("保单归属")
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.policySelectList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        label: item.name
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "topLeft",
        title: item.name
      }
    }, [_vm._v(_vm._s(item.name))])], 1);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("审核状态")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("审核状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "PENDING"
    }
  }, [_vm._v(_vm._s(_vm.$t("待审核")))]), _c("a-select-option", {
    attrs: {
      value: "PASSED"
    }
  }, [_vm._v(_vm._s(_vm.$t("审核通过")))]), _c("a-select-option", {
    attrs: {
      value: "FAILURE"
    }
  }, [_vm._v(_vm._s(_vm.$t("审核不通过")))])], 1)], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", [_c("div", {
    staticStyle: {
      "text-align": "right",
      "margin-bottom": "15px"
    }
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查询")) + " ")])], 1)])], 1)], 1)], 1), _c("a-table", {
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text === "PENDING" ? _vm.$t("待审核") : text === "PASSED" ? _vm.$t("审核通过") : text === "FAILURE" ? _vm.$t("审核不通过") : "") + " ")];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "questionnaireCheck",
                params: {
                  id: record.id,
                  type: 1,
                  auditFlowTypeId: record.auditFlowTypeId,
                  flowMark: record.flowMark
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看")))])];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };